<div class="login-block" [class.spinner-shown]="showSpinner">
    <div *ngIf="showSpinner" class="loading-spinner-ripple">
      <div class="ldio">
        <div></div>
        <div></div>
      </div>
    </div>
  
    <button *ngIf="!showSpinner" class="btn azure-login-btn" (click)="login()">
      <span class="microsoft-logo"></span>
      Login with Microsoft
    </button>
  </div>